<!-- Ячейка статуса проверки ремонта: показывает подпись или компактное действие. -->
<template>
  <div v-if="inspected" class="repair-inspection-status">
    <span class="repair-inspection-status__check">
      <AppIcon name="check" :size="14" />
    </span>
    <span>{{ inspectorName }}</span>
  </div>

  <button
    v-else
    type="button"
    class="repair-inspection-status__button"
    @click.stop="$emit('confirm-repair-inspection', repairId)"
  >
    <AppIcon name="clipboardCheck" :size="16" />
    Подписать
  </button>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "FleetRepairInspectionStatusCell",

  components: {
    AppIcon,
  },

  props: {
    repairId: {
      type: [Number, String],
      required: true,
    },
    inspected: {
      type: Boolean,
      default: false,
    },
    inspectorName: {
      type: String,
      default: "Подписано",
    },
  },

  emits: ["confirm-repair-inspection"],
};
</script>

<style scoped>
.repair-inspection-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
}

.repair-inspection-status__check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #c8e6c9;
  color: #4caf50;
}

.repair-inspection-status__button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  background: var(--color-green);
  color: white;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
  transition: background 0.2s ease;
}

.repair-inspection-status__button:hover {
  background: var(--color-green-hover);
}
</style>
